import './instagram_message_builder.js.coffee'
import '../instagram_message_story_mention.js.coffee'
Namespace 'Models.Builders'

class Models.Builders.InstagramMessageStoryMentionBuilder extends Models.Builders.InstagramMessageBuilder
  constructor: ->
    super()
    @attachments = null

  build: ->
    new Models.InstagramMessageStoryMention(@)
